// Tab-scoped persistence for the parking flow.
//
// The MST store is rebuilt from `defaultStore` on every hard refresh, so flow
// state (selected tickets, plate, type, step) is lost and the user is bounced
// to the landing page. sessionStorage holds the minimal slice needed to
// rebuild the flow on the next mount — tab-scoped, so it dies when the tab
// closes (natural abandon semantics) and never reaches the backend or other
// tabs. No secrets: plate numbers / ticket ids are already client-side.
//
// Mirrors utilities/checkoutPersistence.js (localStorage form fields); this is
// sessionStorage because the flow is tab-scoped, not a cross-session draft.
const STORAGE_KEY = "winit:parkingFlowState"

export const loadFlowState = () => {
  if (typeof window === "undefined") return null
  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY)
    return raw ? JSON.parse(raw) : null
  } catch (e) {
    return null
  }
}

export const saveFlowState = (slice) => {
  if (typeof window === "undefined") return
  try {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(slice))
  } catch (e) {
    // Best-effort — quota/private-mode failures must not break the flow.
  }
}

export const clearFlowState = () => {
  if (typeof window === "undefined") return
  try {
    window.sessionStorage.removeItem(STORAGE_KEY)
  } catch (e) {
    // ignore
  }
}
